module.exports = __webpack_public_path__ + "static/media/event_active.8defa83e.png";